import { Tooltip, Typography } from '@mui/material';
import PSStatusEdit from './PSStatusEdit';
import { AERatingToolTipText, SBM_TOOLTIP_TEXT } from './PSAppConstants';
import {
  SRO_SBM_PROP_NAME,
  SRO_SBM_USER_ID_PROP_NAME
} from '../../../shared/AppConstants';

export const handleDoubleClickEvent = (params, event) => {
  const doubleClickEvent = new MouseEvent('dblclick', {
    view: window,
    bubbles: true,
    cancelable: true
  });
  event.target.dispatchEvent(doubleClickEvent);
};

export const psDefaultStatus = '---';

export function getPSStatusColumnObject(isEditable) {
  return {
    field: 'status',
    align: 'left',
    headerName: 'Status',
    flex: 1,
    editable: isEditable,
    renderHeader: () => (
      <Typography variant="labelMedium" color="primary">
        Status
      </Typography>
    ),
    renderEditCell: (params) => <PSStatusEdit {...params} />
  };
}

export function getAERatingColumn() {
  return {
    field: 'aeRating',
    align: 'left',
    headerName: 'AE Ratings',
    flex: 1,
    minWidth: 150,
    sortable: true,
    renderHeader: () => (
      <>
        <Typography variant="labelMedium" color="primary">
          AE Ratings
        </Typography>
        <Tooltip title={AERatingToolTipText}>
          <fuel-icon name="info_outlined" />
        </Tooltip>
      </>
    )
  };
}

export const sbmColumn = {
  field: SRO_SBM_PROP_NAME,
  headerName: 'SBM',
  flex: 1,
  align: 'left',
  minWidth: 120,
  sortable: true,
  renderHeader: () => (
    <>
      <Typography variant="labelMedium" color="primary">
        SBM
      </Typography>
      <Tooltip title={SBM_TOOLTIP_TEXT}>
        <fuel-icon name="info_outlined" />
      </Tooltip>
    </>
  ),
  renderCell: (params) => (
    <Tooltip title={params?.row[SRO_SBM_USER_ID_PROP_NAME]}>
      <span style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        {params.value}
      </span>
    </Tooltip>
  )
};
